var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"193bab6aa5f2fe3b09161db0846108bae21d4ccc"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["gsalawpartners-com@ant-somers"]={id:"193bab6aa5f2fe3b09161db0846108bae21d4ccc"};
      